import { render } from "./lines_left.svg?vue&type=template&id=5450359c"
const script = {}
script.render = render

export default script